import React, {FunctionComponent} from 'react';
import withStyles, {WithStylesProps} from 'react-jss';
import cn from 'classnames';
import CardSkeleton from './CardSkeleton';

const styles = {
  card: {
    'break-inside': 'avoid',
  },
  wide: {
    'column-span': 'all',
  },
  skeleton: {
    opacity: '0.15',
  },
};

interface CardProps extends WithStylesProps<typeof styles> {
  wide?: boolean
  loading: boolean
  children: React.ReactNode
  className?: string
}

/**
 * Dashboard card
 * @param wide {boolean} True if the card is 2-column wide
 * @param loading {boolean} True if the card should have a loading state
 * @param classes {string} Additional classes
 * @param children {JSX.Element} Card content
 * @param className {string} Additional class
 * @constructor
 */
const Card: FunctionComponent<CardProps> = ({
  wide = false, loading, classes, className, children,
}) => {
  let classNames = cn('bg-gray-light rounded-md py-5 mb-4 self-start', classes.card, className);
  if (wide) {
    classNames = cn(classNames, classes.wide);
  }
  return (
    <div className={classNames}>
      {loading && <CardSkeleton wide={wide}/>}
      {!loading && children}
    </div>
  );
};

export default withStyles(styles)(Card);
